<template>
  <div>
    <vue-progress-bar></vue-progress-bar>
    <v-main>
        <AppBar :handlerSidebar="handleSidebar" />
        <SideBar ref="sidebar"/>
        <Breadcrumb v-if="showBreadcrumb"/>
        <div class="px-5 py-5">
          <router-view></router-view>
        </div>
    </v-main>
  </div>
</template>

<script>
import AppBar from "./components/AppBar";
import SideBar from "./components/SideBar";
import Breadcrumb from "./components/Breadcrumb";

import { state, getters, actions } from '@/store/store';
export default {
  components: { AppBar, SideBar, Breadcrumb },
  data: () => ({
    showBreadcrumb: false,
    drawer: true,
    themeDrawer: false,
  }),
  created(){
    let userData = JSON.parse(localStorage.getItem('user'));
    if(userData !== null){
      state.currentUser = userData.user_name
    }else{
      localStorage.removeItem('token');
      this.$router.push('/login')
    }
  },
  methods: {
    handleSidebar(){
      this.$refs.sidebar.handleDrawer()
    }
  }
};
</script>